var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCubeIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49609 0.0880622C5.82188 -0.0293541 6.17812 -0.0293541 6.50391 0.0880622L11.0039 1.70763C11.5805 1.92256 12 2.49225 12 3.13232V8.86696C12 9.50703 11.5805 10.0762 11.0039 10.2912L6.50391 11.9114C6.17812 12.0295 5.82188 12.0295 5.49609 11.9114L0.995391 10.2912C0.398438 10.0762 0 9.50703 0 8.86696V3.13232C0 2.49225 0.398438 1.92256 0.995391 1.70763L5.49609 0.0880622ZM6 1.51159L1.92984 2.97643L6 4.4408L10.0711 2.97643L6 1.51159ZM6.75 10.218L10.5 8.86696V4.42663L6.75 5.77762V10.218Z",
    fill: "#1B998B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeIco);
export default __webpack_public_path__ + "static/media/cube_ico.3b003a97938bc65f946998512862d7d8.svg";
export { ForwardRef as ReactComponent };